import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Card, Empty } from "@/components/ui/page";
import { Pill } from "@/components/StatusBadge";
import { fmtTime, fmtDuration } from "@/lib/format";

export default function Attendance({ selfOnly }) {
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/attendance", { params: { date } }).then((r) => setRows(r.data)).catch(() => {});
  }, [date]);

  const present = rows.filter((r) => r.status === "present").length;

  return (
    <div>
      <PageHeader title={selfOnly ? "My Attendance" : "Attendance"} subtitle={`${present} present · ${rows.length} records`} testId="attendance-header">
        <input data-testid="attendance-date" type="date" value={date} onChange={(e) => setDate(e.target.value)} className="rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none focus:border-[#08A7A0]" />
      </PageHeader>
      <Card testId="attendance-table">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50">
              <tr className="text-left text-xs font-semibold uppercase tracking-wide text-slate-500">
                <th className="px-4 py-3">Employee</th><th className="px-4 py-3">Process</th><th className="px-4 py-3">Login</th>
                <th className="px-4 py-3">Logout</th><th className="px-4 py-3">Gross</th><th className="px-4 py-3">Break</th>
                <th className="px-4 py-3">Net</th><th className="px-4 py-3">Late</th><th className="px-4 py-3">Status</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 && <tr><td colSpan={9}><Empty /></td></tr>}
              {rows.map((r) => (
                <tr key={r.id} data-testid={`att-row-${r.employee_id}`} className="border-t border-slate-100 hover:bg-slate-50">
                  <td className="px-4 py-3"><div className="font-semibold text-[#0B1F33]">{r.name}</div><div className="text-xs text-slate-400">{r.employee_id}</div></td>
                  <td className="px-4 py-3 text-slate-600">{r.process || "—"}</td>
                  <td className="px-4 py-3 font-mono text-xs">{fmtTime(r.login_time)}</td>
                  <td className="px-4 py-3 font-mono text-xs">{fmtTime(r.logout_time)}</td>
                  <td className="px-4 py-3 font-mono text-xs">{r.gross_seconds ? fmtDuration(r.gross_seconds) : "—"}</td>
                  <td className="px-4 py-3 font-mono text-xs">{r.break_seconds ? fmtDuration(r.break_seconds) : "—"}</td>
                  <td className="px-4 py-3 font-mono text-xs">{r.net_seconds ? fmtDuration(r.net_seconds) : "—"}</td>
                  <td className="px-4 py-3">{r.late_login ? <Pill tone="amber">Late</Pill> : <span className="text-slate-300">—</span>}</td>
                  <td className="px-4 py-3"><Pill tone={r.status === "present" ? "green" : r.status === "leave" ? "teal" : "red"}>{r.status}</Pill></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
